import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NbIconConfig } from '@nebular/theme';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
// import { Column, GridOption, ContextMenu, AngularGridInstance, FileType, Formatter, ExtensionName, FieldType } from 'angular-slickgrid';
import { NbDialogService } from '@nebular/theme';
import { EliminarManualData } from '../entidades/entidades.component';
import { DatePipe } from '@angular/common';
import { AveriasService } from "../servicios/averias.service";
import { ManualesService } from "../servicios/manuales.service";
import { DateAdapter } from '@angular/material/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PerfilesUsuarioService } from "../servicios/perfiles-usuario.service";
import { Subscription } from 'rxjs';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { MatDialog } from '@angular/material/dialog';
import { jsPDF } from "jspdf";
import { AnalyticsService } from '../servicios/analytics.service';
import { finalize } from 'rxjs/operators';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {EliminarManualComponent} from '../eliminar-manual/eliminar-manual.component';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-manuales-operadores',
    templateUrl: './manuales-operadores.component.html',
    styleUrls: ['./manuales-operadores.component.css'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, NbCardModule, NbIconModule, DropdownModule, MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, SpinnerComponent, MultiSelectModule],
    providers: [DatePipe],
  })

export class ManualesOperadoresComponent implements OnInit {

  fileName = '';
  uploadProgress: number = null;
  uploadSub: Subscription;
  requiredFileType = '.pdf';
  uploadedFiles = [];
  idCliente: number;
  manuales= [];
  bloqueoCargar = true;
  bloqueoEliminar = true;
  formData: FormData;
  descripcion: string;
  selectedFile;
  durationInSeconds = 2;
  miArchivo;
  showSpinner: boolean = true;
  eliminarManualData: EliminarManualData;
  fechaAltaArchivo: Date;
  fechaString = '';

  constructor(private dialogService: NbDialogService, private dateFormatter: DatePipe,
    private modalService: BsModalService, private adapter: DateAdapter<any>,
    public usersRol: PerfilesUsuarioService, private modalServiceBoostrap: NgbModal,
    private _snackBar: MatSnackBar, public dialog: MatDialog,
    private svcAnalytics: AnalyticsService, private http: HttpClient,
    private svcManuales: ManualesService) {

  }

  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem('idCliente'));
    this.showSpinner = true;
    this.svcManuales.getManuales(this.idCliente).subscribe( data => {
      if (data["status"] == 200) {
        this.manuales = this.insertarManuales(data);
        this.showSpinner = false;
      } else {
        this.openSnackBar('Ocurrió un error');
        this.showSpinner = false;
      }
    });
  }
  
  onChangeTab(event) {
  }

  onFileSelected(event) {
    const file:File = event.target.files[0];
    
    if (file) {
      this.fileName = file.name;
      this.formData = new FormData();
      this.formData.append("archivoCodificado", file);
      this.formData.append("nombre", this.fileName);
      this.formData.append("idCliente", this.idCliente.toString());

      // this.formData.append("descripcion", this.descripcion); 
      //Como la descripción se habilita para completar una vez seleccionado un archivo para subir, la 'appendeamos' despues.
      this.bloqueoCargar = false;
    }
  }

  cargarArchivo() {
    if(this.descripcion == null || this.descripcion == "") {
      this.openSnackBar('Ingrese una descripción');
      return;
    }
    if(this.descripcion.trim() == "") {
      this.openSnackBar('Ingrese una descripción válida');
      return;
    }
    this.formData.append("descripcion", this.descripcion);
    this.fechaAltaArchivo = new Date();
    this.fechaString = this.dateFormatter.transform(this.fechaAltaArchivo, "dd-MM-yyyy HH:mm");
    this.formData.append("fechaAlta", this.fechaString);

    this.showSpinner = true;
    this.uploadSub = this.svcManuales.uploadManual(this.formData).subscribe(data => {
      if (data.type == HttpEventType.Response) {
        if (data["status"] == 200) {
          this.cancelarCarga();
          this.showSpinner = false;
          this.openSnackBar('Los cambios se guardaron correctamente');
          this.svcManuales.getManuales(this.idCliente).subscribe( data => {
            if (data["status"] == 200) {
              this.manuales = this.insertarManuales(data);
            }
          });
          return;
        } else {
          this.showSpinner = false;
          this.openSnackBar('Ocurrió un error al cargar el archivo');
        }
      }
    })
  }

  cancelarCarga() {
    this.descripcion = "";
    this.fileName = "";
    this.formData = null;
    this.bloqueoCargar = true;
  }

  downloadManual(manual) {
    this.svcManuales.downloadManual(manual.id).subscribe( data => {
      if (data["status"] == 200) {
        this.miArchivo = this.decodificarArchivo(data);

        const linkSource = 'data:application/pdf;base64,' + this.miArchivo.archivoCodificado; //En linkSource quiero guardar el archivo que me llega en formato Base64.
        const downloadLink = document.createElement("a");
        var fileName = manual.nombre;
    
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

      } else {
        this.openSnackBar('Ocurrió un error');
      }
    })
  }

  selectManual(manual) {
    this.selectedFile = {
      nombre: manual.nombre,
      id: manual.id,
    }
    this.bloqueoEliminar = false;
  }

  //Hace el pedido al back para eliminar el archivo (o dejar de mostrarlo)
  eliminarArchivo() {
    this.showSpinner = true;
    this.svcManuales.deleteManual(this.selectedFile.id).subscribe(data => {
      if (data["status"] == 204) {
        this.cancelarCarga();
        this.cancelarEliminar();
        this.showSpinner = false;
        this.openSnackBar('Se eliminó correctamente');
        this.svcManuales.getManuales(this.idCliente).subscribe( data => {
          if (data["status"] == 200) {
            this.manuales = this.insertarManuales(data);
          } else {
            this.openSnackBar('Ocurrió un error');
          }
        });
      } else {
        this.cancelarCarga();
        this.cancelarEliminar();
        this.showSpinner = false;
        this.openSnackBar('Ocurrió un error');
      }
    })
  }

  cancelarEliminar() {
    this.selectedFile = null;
    // this.formData = null;
    this.bloqueoEliminar = true;
  }

  insertarManuales(manuales) {
    let ManualesArray: Array<any> = [];
    manuales.body.forEach(element => {
      ManualesArray.push({
        id: element.id,
        nombre: element.nombre,
        descripcion: element.descripcion,
        fechaAlta: this.dateFormatter.transform(element.fechaAlta, "dd-MM-yyyy HH:mm"),
      })
    })
    return ManualesArray;
  }
  //Esta funcion me crea un objeto con la forma que yo quiero, para usarlo luego. 
  // ya que no puedo acceder directamente a data.body.archivoCodificado en la función que llama al back.
  decodificarArchivo(data) {
    let archivo = {
      archivoCodificado: data.body.archivoCodificado,
      descripcion: data.body.descripcion,
      id: data.body.idCliente, //este es el id del archivo!
      nombre: data.body.nombre,
    }
    return archivo;
  }

  open(nombre: string, idManual: number) {
    this.eliminarManualData = {
      nombre,
      idManual
    }
      this.dialogService.open(EliminarManualComponent, {
        context: {
          data: this.eliminarManualData,
        },
      }).onClose.subscribe(actualizar => {
          this.svcManuales.getManuales(this.idCliente).subscribe( data => {
            if (data["status"] == 200) {
              this.manuales = this.insertarManuales(data);
            }
          });
      });
    }


  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    })
  }
}